module.exports = __webpack_public_path__ + "static/media/WH.e0aeaac3.webp";